import moment from 'moment';
import {
  any,
  aperture,
  equals,
  flatten,
  groupWith,
  head,
  last,
  pipe,
  reverse,
} from 'ramda';
import { timestamp } from '@repo-level/core-front';

import { CMSWeekday, EWeekday } from 'api/cms/base';
import { weekdays } from './cms';

export const getTimeLeftTillEndOfTodayUTC = () => {
  return (moment.utc().endOf('day').valueOf() - moment.utc().valueOf()) / 1000;
};

const checkNumbersConsistent = (subset: number[], range: number[]) =>
  pipe<number[], number[][], boolean>(
    aperture(subset.length),
    any(equals(subset))
  )(range);

export const getTimeLeft = (timeUntil: string | null) => {
  return timeUntil != null
    ? (timestamp(timeUntil) - new Date().getTime()) / 1000
    : 0;
};

export const getTimeLeftFromScheduler = (scheduler?: CMSWeekday[]) => {
  if (!scheduler) return null;

  const currentWeekday = moment.utc().format('dddd');
  const currentWeekdayIndex = weekdays.indexOf(currentWeekday as EWeekday);

  const schedulerIndexes = scheduler
    .map(({ weekday }) => weekdays.indexOf(weekday))
    .sort();

  if (schedulerIndexes.length === 1) {
    return getTimeLeftTillEndOfTodayUTC();
  } else {
    const weekdaysIndexes = weekdays.map((__, idx) => idx);

    // check if sorted scheduler starts from Sunday and ends with Saturday
    // it's needed to understand where is the start of period
    if (
      head(schedulerIndexes) === head(weekdaysIndexes) &&
      last(schedulerIndexes) === last(weekdaysIndexes)
    ) {
      const consecutiveDayIndexesGroups = groupWith(
        (a, b) => a + 1 === b,
        schedulerIndexes
      );

      // if there are more than 2 groups it means that days don't follow each other
      if (consecutiveDayIndexesGroups.length !== 2) {
        return getTimeLeftTillEndOfTodayUTC();
      }

      // there are two groups - one starts from Sunday and second ends on Saturday
      // change their order and find the start day of period
      const daysPeriod = pipe<number[][], number[][], number[]>(
        reverse,
        flatten
      )(consecutiveDayIndexesGroups);

      return last(daysPeriod) === currentWeekdayIndex
        ? getTimeLeftTillEndOfTodayUTC()
        : null;
    } else {
      //check if all numbers (days) follow each other
      if (checkNumbersConsistent(schedulerIndexes, weekdaysIndexes)) {
        return last(schedulerIndexes) === currentWeekdayIndex
          ? getTimeLeftTillEndOfTodayUTC()
          : null;
      } else {
        return getTimeLeftTillEndOfTodayUTC();
      }
    }
  }
};
